import {TextArea as PeacockTextArea} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ITextAreaProps} TextAreaProps
 * @property {boolean} [disabled] When true, text area is disabled.
 * @property {boolean} [required] When true, marks text area as required.
 * @property {boolean} [optional] When true, marks text area as optional.
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] Text area label configuration.
 * @property {string} [value] Text area value.
 * @property {(value: string) => void} [onUpdate] Callback triggered with updated text area value.
 * @property {() => void} [onDownload] Callback triggered when download action is clicked.
 * @property {string} [placeholder] Placeholder text.
 * @property {string | import('react').ReactNode} [helperText] Helper text shown under text area.
 * @property {string} [error] Error text shown under text area.
 * @property {boolean} [htmlMode] When true, renders as code snippet mode.
 * @property {boolean} [showToolbar] When true, renders toolbar actions.
 * @property {boolean} [showCharacterCount] When true, renders character count.
 * @property {boolean} [disableResize] When true, disables resize behavior.
 * @property {boolean} [skeleton] When true, renders skeleton state.
 * @property {string} [variableInputCharacter] Character that triggers variable popover.
 * @property {import('@pepsico-ds/ui').IMenuListItem[]} [variables] Variable options displayed in popover.
 * @property {(variable: import('@pepsico-ds/ui').IMenuListItem) => void} [onVariableSelect] Callback when variable is selected.
 * @property {{showSearch?: boolean, size?: 'medium' | 'small', width?: string, height?: number, emptyStateMessage?: string}} [variablePopoverProps] Variable popover configuration.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS TextArea.
 * Supports all Peacock DS text area props.
 * @param {TextAreaProps} props
 */

export const TextArea = props => {
  return <PeacockTextArea {...props} />
}
